module.exports = __webpack_public_path__ + "img/planetary-rev03.80ccf9bb.jpg";